import React, { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { boardSummary, wipLabel, deptNeon } from '@battleops/shared';
import Icon from '../Icon';
import s from './BoardCard.module.css';

// A department Home's Board card (boards plan §8, built with B7; the phone's desk/BoardCard): the department's board as
// mini bars — Backlog 12 · Next 4 · Doing 2/3 · Review 1 · Done in the last 7 days — WIP over in red (OVER); click →
// /board/department/<id>. Nothing for a department whose board is off (Field never has one).
export default function BoardCard({ dept, data }) {
  const navigate = useNavigate();
  const sum = useMemo(() => (dept && data ? boardSummary(dept, data) : null), [dept, data]);
  if (!sum) return null;
  const neon = deptNeon(dept);
  return (
    <button type="button" className={s.card} style={{ '--n1': neon[1] }} onClick={() => navigate(`/board/department/${dept.id}`)}
      aria-label={`${sum.board.name}: ${sum.columns.map((c) => `${c.label} ${wipLabel(c)}${c.over ? ' over the limit' : ''}`).join(', ')}. Open the board`}>
      <div className={s.head}><h2>Board</h2><span>{sum.open} open</span><b>{sum.board.name}<Icon name="chevron-right" size={13} /></b></div>
      <div className={s.rows}>
        {sum.columns.map((c) => (
          <div key={c.id} className={s.row}>
            <span className={s.label}>{c.kind === 'done' ? `Done · ${sum.doneDays} d` : c.label}</span>
            <span className={s.track}><i style={{ width: `${c.count ? Math.max(4, (c.count / sum.max) * 100) : 0}%`, background: c.over ? '#FF7A70' : c.kind === 'done' ? '#3FD69B' : c.kind === 'review' ? '#FFD23F' : neon[1], opacity: c.kind === 'done' ? 0.55 : 1 }} /></span>
            <span className={s.count} style={c.over ? { color: '#FF7A70' } : undefined}>{wipLabel(c)}</span>
            <span className={s.over}>{c.over ? 'OVER' : ''}</span>
          </div>
        ))}
      </div>
    </button>
  );
}
